/**
 * 文字转语音
 */

var emtts = {
    init: function(options){
    	var _this = this;
        this.options = options;
        this.audiolist = [];
        this.nowplay = 0;
        this.nowplayid = '';
        this.playing = false;
        this.preloadfirst = false;//预加载第一条
        this.preloadnext = true; //预加载开关 播放时开始加载下一条


        this.options.audiolist.forEach(function(v, i){
            //this.kxaudio_list.push(new kxaudio(v.id, v.text));
            this.audiolist.push({
                id: v.id,
                text: v.text,
                src: this.getAudioSrc(v.text)
            });
        }.bind(this));
        //console.info(this.audiolist);

        if(this.preloadfirst){ //加载第一条
            this.loadaudio(this.audiolist[0]);
        }


        this.audio = document.createElement('audio');
        this.nextaudio = document.createElement('audio');
       
        //进度条
        var progress_timer = null;
        this.audio.addEventListener("playing", function() {
        	try{
        		clearInterval(progress_timer);
        	}
        	catch (e){
        		
        	}
        	progress_timer = setInterval(function(){
        		this.showpro();
        	}.bind(this), 15);
            this.showpro();
        }.bind(this), false);

        this.audio.addEventListener("pause ended", function() {
            try{
            	clearInterval(progress_timer);
            }
            catch (e){
            	
            }
        }.bind(this), false);  

        //播放结束
        this.audio.addEventListener("ended", function() {
        	ttsui.closePlayingIcon();
            ttsui.btn.pause.hide();
			ttsui.btn.play.css('display','inline-block');
			this.nextPlay();
			
        }.bind(this), false);          
        
        // var audio_pbtn = $('#audio_pbtn');
        // var audio_pbar = $('#audio_pbar');
        // audio_pbtn.on('touchstart', function (){
        // 	$(this).addClass('ontouch');
        // 	try{
        // 		clearInterval(progress_timer);
        // 	}
        // 	catch (e){
        		
        // 	}
        	
        // });

        // var barmax_width = $(window).width();
        // audio_pbtn.on('touchmove', function (e){
        // 	var touchx = e.originalEvent.touches[0].clientX;
        // 	var touch_per = touchx / barmax_width * 100;


        // 	if (touch_per > 100) {
        // 		touch_per = 100;
        // 	}

        // 	if (touch_per <= 0) {
        // 		touch_per = 0;
        // 	}

        // 	$(this).css('left', touch_per + '%');
        // 	audio_pbar.css('width', touch_per + '%');
        // 	e.preventDefault();
        // 	return false;
        // });       
         
        // audio_pbtn.on('touchend', function (){
        // 	$(this).removeClass('ontouch');
        // 	var currentTime = 0;
        // 	var touch_per = parseFloat($(this).css('left').replace('%', '')) / barmax_width;
        // 	console.info(touch_per);
        // 	_this.audio.currentTime = _this.audio.duration * touch_per;
        // 	console.info(_this.audio.currentTime);
        // });        
    },

    showpro: function (){
    	var play_progress = (this.audio.currentTime/this.audio.duration) * 100 + '%';
    	var audio_pbar = $('#audio_pbar');
        var audio_pbtn = $('#audio_pbtn');
        audio_pbar.css({width: play_progress });
        audio_pbtn.css({left: play_progress });
    },

    /**
     * 增加数据
     */
    appendData: function(datalist){
    	//console.info(this.audiolist);
    	datalist.forEach(function (v){
    		this.audiolist.push({
                id: v.id,
                text: v.text,
                src: this.getAudioSrc(v.text)
    		});
    	}.bind(this));
    },
    getAudioSrc : function(text){
        return 'http://tts.eastmoney.com/api/tts?text=' + encodeURI(text);
    },
    playaudio: function(i){
    	try{
    		i = parseInt(i);
    	}
    	catch (e){
    		
    	}
    	
    	//console.info(i);
        this.nowplay = i;
        this.audio.src = this.audiolist[i].src;
        this.nowplayid = this.audiolist[i].id;
        this.audio.play();

        ttsui.btn.play.hide();
		ttsui.btn.pause.css('display','inline-block');   
        
        ttsui.changetext(this.audiolist[i].text);

        if(this.preloadnext && i < this.audiolist.length){ //预加载下一条
            setTimeout(function(){
                this.nextaudio.src = this.audiolist[i + 1].src;
            }.bind(this),500);
            
        }
    },
    /**
     * 立即播放文本
     * 
     * @param {any} text
     */
    playtext: function(text){
        this.settext(text);
        //this.play();
    },
    findById: function(id){
        for(i in this.audiolist){
            if(this.audiolist[i].id == id){
                return i;
            }
        }
    },
    /**
     * 播放，如果没有指定id则播放第一条
     */
    play: function(id){
        if( id == undefined){
            //this.loadaudio(0);
            this.playaudio(0);
            this.nowplay = 0;
        }
        else{
        	if (id == this.nowplayid) {
        		if (this.audio.paused) {
        			ttsui.btn.play.hide();
					ttsui.btn.pause.css('display','inline-block');        			
        			this.audio.play();
        		}
        		else{
	        		//ttsui.btn.pause.hide();
					//ttsui.btn.play.css('display','inline-block');        			
	        		this.audio.pause();
	        		ttsui.btn.pause.hide();
					ttsui.btn.play.css('display','inline-block');
					ttsui.closePlayingIcon();
        		}
        	}
        	else{
        		ttsui.btn.play.hide();
				ttsui.btn.pause.css('display','inline-block');       
        		this.playaudio(this.findById(id));
        	}
            
            //this.nowplay(i)
        }
        ttsui.show();
    },
    /**
     * 在暂停之后继续播放
     */
    continuePlay: function(){
        this.audio.play();
    },
    /**
     * 重置播放进度
     */
    reset: function(i){
        this.audiolist[i].audio.currentTime = 0;
    },
    /**
     * 重置所有音频的播放进度
     */
    resetall: function(){
        this.audiolist.forEach(function(v, i){
            v.audio.currentTime = 0;
        });
    },
    stop: function(){
        this.audio.pause();
        this.audio.currentTime = 0;
    },
    /**
     * 暂停目前播放的音频
     */
    pause: function(){
        ttsui.btn.pause.hide();
		ttsui.btn.play.css('display','inline-block');  
        this.audio.pause();
    },
    /**
     * 播放下一个音频
     */
    nextPlay: function(){
        this.nowplay ++;
        if(this.nowplay > this.audiolist.length - 1){
            //this.nowplay = this.audiolist.length - 1;
            ttsui.uibox.slideUp(200, function (){
				$('body').css('padding-bottom', 0);
			});
			ttsui.closePlayingIcon();
            return false;

        }
        this.playaudio(this.nowplay);
        ttsui.showPlayingIcon();
    },
    /**
     * 播放上一个音频
     */
    prePlay: function(){
        this.nowplay --;
        if(this.nowplay <= 0){
            this.nowplay = 0;
        }
        this.playaudio(this.nowplay);
    }
}

var ttsui = {
	init: function (){
		this.uibox = $('#audioui');
		this.btn = {};
		this.btn.pause = $('.audio_pause', this.uibox);
		this.btn.next = $('.audio_next', this.uibox);
		this.btn.pre = $('.audio_pre', this.uibox);
		this.btn.close = $('.audio_close', this.uibox);
		this.btn.play = $('.audio_play', this.uibox);		
		this.bind();	
	},
	bind: function (){
		var _this = this;
		//关闭
		this.btn.close.on('click', function (){
			emtts.stop();
			_this.uibox.slideUp(200, function (){
				$('body').css('padding-bottom', 0);
			});
			_this.closePlayingIcon();
			//return false;
		});
		//暂停
		this.btn.pause.on('click', function (){
			emtts.pause();
			this.btn.pause.hide();
			this.btn.play.css('display','inline-block');
			_this.closePlayingIcon();
			return false;
		}.bind(this));
		//播放
		this.btn.play.on('click', function (){
			emtts.continuePlay();
			this.btn.pause.css('display','inline-block');
			this.btn.play.hide();
			_this.showPlayingIcon();
			return false;
		}.bind(this));
		//上一个
		this.btn.pre.on('click', function (){
			emtts.prePlay();
			this.btn.pause.css('display','inline-block');
			this.btn.play.hide();
			_this.closePlayingIcon();
			_this.showPlayingIcon();
			//return false;
		}.bind(this));
		//下一个
		this.btn.next.on('click', function (){
			emtts.nextPlay();
			this.btn.pause.css('display','inline-block');
			this.btn.play.hide();
			_this.closePlayingIcon();
			_this.showPlayingIcon();
			//return false;
		}.bind(this));		
	},
	show: function (){
		//this.btn.play.hide();
		//this.btn.pause.css('display','inline-block');
		this.uibox.slideDown(200, function (){
			$('body').css('padding-bottom', 50);
		});
	},
	changetext: function (text){
		$('#audiotextyw').text(text);
	},
	closePlayingIcon: function (){
		$('#kxlist .playing').removeClass('playing');
	},
	showPlayingIcon: function (){
		var id = emtts.nowplayid;
		$(".kxitem[data-id='" + id + "'] .kxaudio").addClass('playing');
	}
}

ttsui.init();

module.exports = emtts;


//////////////////
// WEBPACK FOOTER
// ./dev/modules/tts/tts.js
// module id = 17
// module chunks = 11